<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <fgbcl-errors></fgbcl-errors>

  <div class="form-group">
    <div class="form-floating">
      <input
        id="username"
        class="form-control"
        name="username"
        type="text"
        formControlName="username"
        placeholder="Insert email here"
      />
      <label for="username">{{ 'login.page.label.email' | translate }}</label>
    </div>
    <div *ngIf="loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched" class="invalid-feedback">
      <div class="alert-danger">{{ 'login.page.required' | translate }}</div>
    </div>
  </div>

  <div class="form-group">
    <div class="form-floating">
      <input
        id="password"
        class="form-control"
        name="password"
        type="password"
        formControlName="password"
        placeholder="Insert password here"
      />
      <label for="password">{{ 'login.page.label.password' | translate }}</label>
    </div>
    <div *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched" class="invalid-feedback">
      <div class="alert-danger">{{ 'login.page.required' | translate }}</div>
    </div>
  </div>
  <div class="panel-text forgot-password font-size-12 d-flex align-items-center">
    <p class="forgot-pw-message me-1 my-0">{{ 'login.page.forgot.pw.message' | translate }}</p>
    <a class="forgot-pw fw-bold" href="https://www.mlb.com/forgot-password">{{ 'login.page.forgot.pw' | translate }}</a>
  </div>

  <div class="action-wrapper">
    <button
      [disabled]="loading"
      class="btn btn-primary btn-block text-white login-button font-size-14 w-100 fw-bold"
      type="submit"
    >
      <span *ngIf="!loading">Login</span>
      <fgbcl-loading [size]="'small'" *ngIf="loading"></fgbcl-loading>
    </button>

    <div class="separator my-2">
      <span>Or</span>
    </div>

    <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.partners'">
      <a class="btn btn-white border btn-block received-button w-100 fw-bold" [routerLink]="['/register/partner']">{{
        'login.page.recivied.partner' | translate
      }}</a>
    </ng-container>

    <a
      [href]="'login.new.member.link' | translate"
      class="btn btn-black btn-block text-white login-button font-size-14 w-100 fw-bold"
    >
      <span>{{ 'login.not.member' | translate }}</span>
    </a>
  </div>
</form>
